import { getParent } from '../../js/helper';
import { sendTracking } from './../../js/tracking';

class FormInput {
    constructor (element, options) {
        const defaults = {
            filledClassname: 'is--filled'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$input = element;
        this.$inputField = this.$input.querySelector('input, textarea, select');

        if (this.$inputField === null) {
            console.error('no input, textarea, select found');
            return;
        }

        this.initialize();
    }

    initialize () {
        this.checkFilled();

        if (this.$inputField.tagName.toLowerCase() === 'select') {
            this.handleSelect(this.$inputField);
        } else {
            if (this.$inputField.getAttribute('data-datepicker') !== null) {
                this.handleDatePicker(this.$inputField);
            } else {
                this.setEvents();

                if (this.$inputField.getAttribute('type') !== 'checkbox' && this.$inputField.getAttribute('type') !== 'radio') {
                    this.addDeleteButton(this.$input, this.$inputField);
                }
            }
        }
    }

    addDeleteButton ($fieldWrapper, $field) {
        const $deleteButton = document.createElement('span');
        $deleteButton.classList.add('form__delete');
        $fieldWrapper.appendChild($deleteButton);

        $deleteButton.addEventListener('click', (e) => {
            $field.focus();
            $field.value = '';
            e.preventDefault();
        });
    }

    handleDatePicker ($datePicker) {
        if (!window.Modernizr.ie11) {
            import('../../components/form/date-picker').then(({ DatePicker }) => {
                const datePickerAPI = new DatePicker($datePicker); // eslint-disable-line
            });
        }
    }

    handleSelect ($select) {
        import('../../components/form/select-box').then(({ SelectBox }) => {
            const selectBoxAPI = new SelectBox($select);
            const selectBox = selectBoxAPI.selectbox;

            selectBox.on('selectr.init', () => {
                $select.API = selectBox;
            });

            selectBox.on('selectr.change', (option) => {
                this.removeError();
                this.checkFilled();
                this.fireSelectTracking(this.$input, option);
            });
        });
    }

    setEvents () {
        let unfocusTimeout = null;

        this.$inputField.addEventListener('keyup', () => {
            this.removeError();
            this.checkFilled();
        });

        this.$inputField.addEventListener('change', () => {
            this.removeError();
            this.checkFilled();
        });

        this.$inputField.addEventListener('focus', () => {
            clearTimeout(unfocusTimeout);
            this.$inputField.classList.add('is--focused');
        });

        this.$inputField.addEventListener('blur', () => {
            clearTimeout(unfocusTimeout);
            unfocusTimeout = window.setTimeout(() => {
                this.$inputField.classList.remove('is--focused');
            }, 150);
        });
    }

    removeError () {
        const $parent = getParent(this.$inputField, '.has--error') || getParent(this.$inputField, '.has--warning');
        if ($parent) {
            $parent.classList.remove('has--error');
            $parent.classList.remove('has--warning');
        }
    }

    checkFilled () {
        const value = this.$inputField.value;
        let filled = false;

        switch (true) {
        case (value === ''):
            filled = false;
            break;

        case (value === '-1'):
            filled = false;
            break;

        case (typeof value === 'object'):
            if (value.length === 0) {
                filled = false;
            } else if (value.indexOf('-1') === -1) {
                filled = true;
            } else {
                this.$inputField.value = [];
                filled = false;
            }
            break;

        default:
            filled = true;
            break;
        }

        if (filled === true) {
            this.$input.classList.add('is--filled');
        } else {
            this.$input.classList.remove('is--filled');
        }
    }

    fireSelectTracking ($element, option) {
        // console.log('fireTracking -> $element', $element);
        const trackingType = $element.getAttribute('data-tracking-type');
        // console.log('fireTracking -> trackingType', trackingType);
        if (trackingType === 'country-select') {
            const trackingData = {
                category: 'service center',
                action: 'select country',
                label: option.value
            };
            sendTracking(trackingData);
        }
    }
}

export { FormInput };
